import { supabase } from '../lib/supabase';
import { veiculoHistoricoMotoristaService } from './veiculoHistoricoMotoristaService';
import { veiculoService } from './veiculoService';

export const pessoaCascadeService = {
  /**
   * Executado sempre que uma pessoa é inativada no sistema.
   * Desvincula automaticamente a pessoa de veículos da frota, desativa veículos de agregados
   * e registra no histórico de condutores.
   */
  async desativarVinculosPessoa(pessoaId: number): Promise<{ veiculosDesvinculados: number; veiculosDesativados: number }> {
    if (!pessoaId || isNaN(pessoaId)) {
      return { veiculosDesvinculados: 0, veiculosDesativados: 0 };
    }

    let veiculosDesvinculados = 0;
    let veiculosDesativados = 0;

    try {
      // 1. Busca todos os veículos onde esta pessoa é motorista ou agregado
      const { data: veiculosVinculados, error: fetchErr } = await supabase
        .from('veiculos')
        // status_frota/ativo não são colunas de `veiculos` (ficam em
        // system_preference) — pedi-las derrubava a consulta inteira (42703).
        .select('id, placa, motorista_id, agregado_id')
        .or(`motorista_id.eq.${pessoaId},agregado_id.eq.${pessoaId}`);

      if (fetchErr) {
        console.warn('Aviso ao buscar veículos da pessoa para inativação:', fetchErr.message);
      }

      if (veiculosVinculados && veiculosVinculados.length > 0) {
        for (const v of veiculosVinculados) {
          const isAgregadoOwner = Number(v.agregado_id) === Number(pessoaId);
          const isMotorista = Number(v.motorista_id) === Number(pessoaId);

          const updatePayload: any = {};

          if (isMotorista) {
            updatePayload.motorista_id = null;
            veiculosDesvinculados += 1;
          }

          if (isAgregadoOwner) {
            updatePayload.agregado_id = null;
            updatePayload.status_frota = 'desativado';
            updatePayload.ativo = false;
            updatePayload.data_desativacao = new Date().toISOString();
            veiculosDesativados += 1;
          }

          // Via veiculoService: ele separa os campos reais da tabela dos que
          // moram em system_preference (ativo/status_frota/data_desativacao).
          // O update direto falhava com PGRST204 e o veículo nunca era liberado.
          try {
            await veiculoService.update(String(v.id), updatePayload);
          } catch (upErr: any) {
            console.warn(`Falha ao desvincular o veículo ${v.placa || v.id}:`, upErr.message);
          }

          // Registra a desvinculação no histórico de condutores do veículo
          try {
            await veiculoHistoricoMotoristaService.registrarTrocaMotorista({
              veiculo_id: String(v.id),
              placa: v.placa,
              novo_motorista_id: null,
              novo_motorista_nome: 'Sem motorista (Cadastro inativado)',
              motivo: 'Desvinculado automaticamente por inativação do cadastro da pessoa',
            });
          } catch (histErr) {
            console.warn(`Aviso ao registrar histórico para o veículo ${v.placa}:`, histErr);
          }
        }
      }
    } catch (err) {
      console.error(`Erro na desativação em cascata da pessoa #${pessoaId}:`, err);
    }

    return { veiculosDesvinculados, veiculosDesativados };
  }
};
